import Section from '/components/elements/Section'
import Container from '/components/elements/Container'
import Grid from '/components/elements/Grid'
import EstateCard from '/components/custom/EstateCard'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import Button from '/components/elements/Button'
import LineSeparator from '/components/elements/LineSeparator'
import { useRouter } from 'next/router'

const Properties = ({
  properties,
  generalTranslation,
  scrollRef,
  translations
}) => {
  const { isTablet, isSmallMobile } = useResponsive()
  const router = useRouter()

  let totalCards = isTablet ? 6 : 9
  let gridSetup = isSmallMobile ? 1 : isTablet ? 2 : 3

  if (properties) {
    return (
      <Section variant={['gray', 'center']} sectionRef={scrollRef}>
        <Container variant={['-xxl']}>
          <h2>{translations.title[router.locale]}</h2>
          <Grid variant={[`grid-${gridSetup}`]}>
            {properties.map((item, index) => {
              if (index < totalCards)
                return (
                  <EstateCard
                    translations={generalTranslation}
                    key={index}
                    {...item}
                  />
                )
            })}
          </Grid>

          <LineSeparator variant={['vertical']} />

          <h3
            dangerouslySetInnerHTML={{
              __html: translations.subtitle[router.locale]
            }}
          ></h3>

          <Button href="/real-estate/search" variant={['color-primary']}>
            {`${translations.all[router.locale]} ${properties.length} ${
              translations.properties[router.locale]
            }`}
          </Button>
        </Container>
      </Section>
    )
  }
  return
}

export default Properties
